import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthService } from '@src/app/services/user-managment/authentication/authentication.service';
import {RESET_PASSWORD_STATUS,VERIFY_TOKEN_STATUS} from '../../constant/statuses'
import {UserProfileService} from '../../services/user-managment/user-profile/user-profile.service'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

 subscription = new Subscription()
  error = false

  email =  ''
  token =  ''

  constructor(public userProfileService : UserProfileService,public authService:AuthService,public route : ActivatedRoute, public translate : TranslateService,public router: Router) { }

  ngOnInit(): void {
    this.subscription.add(
      this.route.queryParamMap.subscribe((param)=>{
        this.email = param.get('email')??''
        this.token = param.get('token')?decodeURIComponent(param.get('token')!) :''


        this.authService.verifyResetPasswordToken(this.token,this.email)
        this.authService.initResetPasswordForm(this.token,this.email)
      })
    )


    this.subscription.add(
      this.authService.notify.subscribe({
        next : (status)=>{
          if(status === RESET_PASSWORD_STATUS.success){
            this.router.navigate(['/'])
          }else if (status === RESET_PASSWORD_STATUS.faild) {
            this.error = true;
          } else if (status === VERIFY_TOKEN_STATUS.faild) {
            Swal.fire({
              icon: 'error',
              title: 'The reset password link has expired.',
              text: 'Please request a new one to reset your password.',
            });
            this.router.navigate(['/']);
          }
        }
      })
    )


    this.subscription.add(
      this.authService.notify.subscribe({
        next : ()=>{
          if(this.userProfileService.user.email.toLowerCase()!== this.email.toLowerCase()&&this.email.toLowerCase() ){
            this.authService.removeToken()
          }
        }
        
      })
    )
  }


  onReset() {
    if (this.resetPasswordForm.valid) {
      this.authService.restPassword();
    }
  }

  get lang() {
    return this.translate.currentLang;
  }

  get isLoading() {
    return this.authService.isLoading;
  }

  get resetPasswordForm() {
    return this.authService.resetPasswordForm;
  }

  get getPasswordErrorMessage() {
    return this.authService.getPasswordErrorMessage;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
